import {FlexBox} from "@contents/components/customStyledComponent";
import {Grid, Typography} from "@mui/material";
import React, {ReactNode} from "react";
import styled from "styled-components";


const LabelCompContainer = styled(FlexBox)(() => ({
    width: "100%",
    height: '100%',
    gap: "8px",
    alignItems: 'center',
  })
);

type LabelCompType = {
  label?: string | ReactNode;
  children: ReactNode;
};

const LabelSimpleMobileComp = ({label, children}: LabelCompType) => {
  return (
    <LabelCompContainer>
        {
            typeof label === 'string' ?
                <Typography variant={"body2"} whiteSpace={'nowrap'} color={(theme) => theme.palette.eliga_399.main}>
                    {label}
                </Typography>
                :
                label
        }
        <Typography>{children}</Typography>
    </LabelCompContainer>
  );
};

export default LabelSimpleMobileComp;
